module.exports = __webpack_public_path__ + "static/img/product_icon_15_zh.40e5e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_15_zh.png
// module id = OQCk
// module chunks = 34